export default __webpack_public_path__ + "static/media/118_artifeu_kawai_0001.84061547.png";